import { graphql } from "~/gql";

export const FIND_RELEVANT_MATTERS_QUERY = graphql(/* GraphQL */ `
  query FindRelevantMatters(
    $text: String!
    $clientName: String!
    $filter: RelevantMattersFilter
    $fetchAccruedFees: Boolean = false
    $distanceThreshold: Float = 2
    $maxResults: Int = 50
    $additionalSearchText: String
  ) {
    findRelevantMatters(
      text: $text
      clientName: $clientName
      filter: $filter
      fetchAccruedFees: $fetchAccruedFees
      distanceThreshold: $distanceThreshold
      maxResults: $maxResults
      additionalSearchText: $additionalSearchText
    ) {
      matters {
        __typename
        relevanceScore
        reference
        id
        isParent
        isFavourite
        title
        template
        pricingType
        pricingLevel
        pricingTarget
        client {
          id
          name
          externalReference
          type
        }
        organisationalUnit {
          __typename
          id
          name
          parent {
            id
            name
          }
        }
        updatedAt
        createdAt
        status
        createdBy {
          id
          userName
          displayName
        }
        externalMatterId
        externalReference
        currency {
          id
          code
          symbol
        }
        teamMemberships {
          ...TeamMembershipParts
        }
      }
      accruedFees {
        ...AccruedFeeFragment
      }
    }
  }
`);
